/* Compact Bed Free - in-page CTA smooth scroll.
   Section wrapper ids in a JSON template look like
   "shopify-section-template--<dynamic>__main-product", so we match by the
   stable "__<key>" suffix instead of a hardcoded id (works on staging + live). */
(function () {
  function scrollToMatch(substr) {
    var el = document.querySelector('[id*="' + substr + '"]');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    }
    return false;
  }

  document.addEventListener(
    'click',
    function (e) {
      // Primary "Обрати колір і замовити" buttons -> scroll to the buy box.
      var cta = e.target.closest('a.cbf-btn--cta');
      if (cta) {
        if (scrollToMatch('__main-product')) e.preventDefault();
        return;
      }
      // USP ghost button "Переглянути 5 режимів" -> scroll to the modes section.
      var ghost = e.target.closest('.cbf-usp a.cbf-btn--ghost');
      if (ghost) {
        if (scrollToMatch('__cbf_modes')) e.preventDefault();
      }
    },
    false
  );
})();
